module.exports = __webpack_public_path__ + "vue_assets/img/img_assetpack_base.264e5fd3.jpg";